module.exports = __webpack_public_path__ + "static/media/15.2b19b704.mp3";